import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './style.css'; // Assuming we have a CSS file for styles.
import { useNavigate, useParams } from 'react-router-dom';

export default function Reservation() {
    const { uker } = useParams();

    const navigate = useNavigate();

    const overlayStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url(../assets/logo/logo-kejati.png)', // Adjust path as needed
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        opacity: 0.1,
        pointerEvents: 'none',
    };

    const [unitKerja, setUnitKerja] = useState(null);
    const [reservationCode, setReservationCode] = useState('');
    const [reservationData, setReservationData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_UKER = "api/kejati/reservation/subprojectdetail";

    const fetchData = async (url, headers) => {
        try {
            const response = await axios.get(url, { headers });
            return response.data;
        } catch (err) {
            // setError("Gagal memuat data. Silakan coba lagi.");
            return null;
        }
    };

    // Handle input change
    const handleInputChange = (e) => {
        setReservationCode(e.target.value);
    };

    // Fetch reservation data
    const fetchReservationData = async (code) => {
        setLoading(true);
        setError(null); // Reset previous error
        setReservationData(null); // Reset previous data

        try {
            // Replace the URL with your actual API endpoint
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/kejati/mkios/reservation?code=${code}&uker=${uker}`);
            setReservationData(response.data); // Set reservation data
        } catch (err) {
            setError('Reservasi tidak ditemukan.');
        } finally {
            setLoading(false);
        }
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        if (reservationCode.trim()) {
            fetchReservationData(reservationCode);
        }
    };

    useEffect(() => {
        if (uker == null) {
            navigate(`/mkios`);
        }

        fetchData(`${BASE_URL}${PATH_UKER}?uker=${uker}`).then((response) => {
            setUnitKerja(response);
        }).finally(() => {
            setLoading(false);
        });
    }, [uker]);

    return (
        <div>
            <div style={overlayStyle}></div>
            <div className="reservation-form-container">

                <h1>Cek Kode Reservasi</h1>
                <form onSubmit={handleSubmit} className="reservation-form">
                    <label htmlFor="reservationCode">Ketik Kode Reservasi disini:</label>
                    <input
                        autoFocus={true}
                        type="text"
                        id="reservationCode"
                        name="reservationCode"
                        value={reservationCode}
                        onChange={handleInputChange}
                        required
                        placeholder="e.g. ABC123"
                    />
                    <button type="submit" disabled={loading}>
                        {loading ? 'Memeriksa...' : 'Cek Reservasi'}
                    </button>
                </form>

                {error && <p className="error-message">{error}</p>}

                {reservationData && (
                    <div className="reservation-result">
                        <h2>Detail Reservasi:</h2>
                        <p><strong>Kode:</strong> {reservationData.code}</p>
                        <p><strong>Nama:</strong> {reservationData.name}</p>
                        <p><strong>Tanggal:</strong> {reservationData.date}</p>
                        <p><strong>Status:</strong> {reservationData.status}</p>
                        {/* Add more reservation details here as needed */}

                        {/* mkios-new-queue-taking-goods */}
                        <a href={`/mkios-new-queue-taking-goods/${uker}/${reservationData.code}`} className="print-button">
                            Ambil Antrian
                        </a>
                    </div>
                )}
                <div className="bg-yellow-100 p-4 my-4 rounded mb-4 text-sm text-gray-800 text-left">
                    <h2 className="font-semibold mb-2">Petunjuk Pemindaian Kode QR</h2>
                    {/* <ol className="list-disc list-inside"> */}
                    <ul className="list-decimal pl-5">
                        <li><strong>Siapkan Kode QR Anda:</strong> Pastikan Anda memiliki Kode QR Reservasi yang dikirimkan melalui Whatsapp sebelumnya.</li>
                        <li><strong>Arahkan Kode QR ke Scanner:</strong> Tempatkan Kode QR di depan pemindai yang terletak di bagian bawah kiosk. Pastikan Kode QR berada dalam area pemindaian dengan posisi yang jelas dan tidak terlipat atau terhalang.</li>
                        <li><strong>Tunggu Konfirmasi:</strong> Sistem akan membaca Kode QR Anda secara otomatis. Jika berhasil, informasi reservasi akan ditampilkan di layar.</li>
                        <li><strong>Jika Gagal Memindai:</strong>
                            <ul className="list-disc pl-5">
                                <li>Pastikan Kode QR tidak rusak atau buram.</li>
                                <li>Coba pindahkan Kode QR lebih dekat atau lebih jauh dari scanner.</li>
                                <li>Jika masih tidak bisa, Anda dapat memasukkan kode reservasi secara manual pada kolom yang tersedia.</li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
